export default class EventManager {
    // Подписчики
    subscribers: Array<(...params) => void>;

    constructor() {
        this.subscribers = [];
    }

    // Подписаться на изменения
    subscribe = (callback: (...params) => void) => {
        this.subscribers.push(callback);
    };

    // Сгенерировать событие
    dispatch = (...params) => {
        this.subscribers.forEach(_ => _(...params));
    };
}
